var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header p-0", attrs: { id: "headingFeatureable" } },
      [
        _c(
          "a",
          {
            staticClass: "btn btn-block text-left p-3",
            attrs: {
              "data-toggle": "collapse",
              role: "button",
              href: "#collapseFeatureable",
              "aria-expanded": "false",
              "aria-controls": "collapseFeatureable",
            },
          },
          [
            _c("h6", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.title`))),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse",
        attrs: {
          id: "collapseFeatureable",
          "aria-labelledby": "headingFeatureable",
          "data-parent": "",
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-sm-auto align-self-sm-center mb-3" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    { staticClass: "form-check city-form-check pl-0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.status,
                            expression: "form.status",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: `cb-featureable`,
                          name: `cb-featureable`,
                          disabled: _vm.readonlyForm || !this.hasResources,
                          "false-value": false,
                          "true-value": true,
                          "data-vv-scope": _vm.vScope,
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.status)
                            ? _vm._i(_vm.form.status, null) > -1
                            : _vm.form.status,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.status,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "status",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "status",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "status", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label h-auto",
                          attrs: { for: `cb-featureable` },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-start",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.modelTranslateID}.form.status`
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.form.status },
                          expression: "{required: form.status}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.disableField,
                        disabled: _vm.disableField,
                        id: "input-integration-id",
                        name: "integration-id",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "integration-id",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("integration-id", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.integration_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "integration_id",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.integration_id",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(
                              `${_vm.modelTranslateID}.form.integration_id`
                            )
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.disableField,
                        id: "input-acl-code",
                        name: "acl-code",
                        label: "name",
                        options: _vm.acls,
                        reduce: (option) => option.code,
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "acl-code",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("acl-code", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.acl_code,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "acl_code",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.acl_code",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(`${_vm.modelTranslateID}.form.acl_code`)
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.subtypes.length
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("LayerSubtype", {
                      attrs: {
                        idPanel: _vm.idPanel,
                        idSubPanel: `${_vm.idSubPanel}.subtypes`,
                        panelCfg: _vm.panelCfg,
                        baseTranslateID: _vm.baseTranslateID,
                        vScope: _vm.vScope,
                        readonlyForm: _vm.disableField,
                        subtypes: _vm.subtypes,
                      },
                      model: {
                        value: _vm.form.subtypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "subtypes", $$v)
                        },
                        expression: "form.subtypes",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showConfig
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h6", { staticClass: "font-weight-normal" }, [
                        _vm._v(
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.form.group`))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mt-2" }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.form.typenames ?? [], function (typename, idx) {
                      return _c(
                        "div",
                        { key: `typename-${idx}`, staticClass: "col-sm" },
                        [
                          _c("LayerTypenameForm", {
                            attrs: {
                              idx: idx,
                              vScope: _vm.vScope,
                              parendId: _vm.idSubPanel,
                              readonlyForm: _vm.readonlyForm,
                              baseTranslateID: _vm.baseTranslateID,
                              showFieldId: true,
                              showFieldName: true,
                            },
                            on: {
                              onReset: function ($event) {
                                return _vm.onResetProperties(typename)
                              },
                            },
                            model: {
                              value: _vm.form.typenames[idx],
                              callback: function ($$v) {
                                _vm.$set(_vm.form.typenames, idx, $$v)
                              },
                              expression: "form.typenames[idx]",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }